/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input,
    ContentChildren,
    forwardRef,
    QueryList
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { CollectionNestedOption } from '../../core/nested-option';
import { DxiLocationComponent } from './location-dxi';



export class DxiMarkerComponent extends CollectionNestedOption {
    
    get iconSrc(): string {
        return this._getOption('iconSrc');
    }
    set iconSrc(value: string) {
        this._setOption('iconSrc', value);
    }

    
    get location(): string|
        Array<number|
        { lat?: number, lng?: number }> {
        return this._getOption('location');
    }
    set location(value: string|
        Array<number|
        { lat?: number, lng?: number }>) {
        this._setOption('location', value);
    }

    
    get onClick(): Function {
        return this._getOption('onClick');
    }
    set onClick(value: Function) {
        this._setOption('onClick', value);
    }

    
    get tooltip(): string|
        { isShown?: boolean, text?: string } {
        return this._getOption('tooltip');
    }
    set tooltip(value: string|
        { isShown?: boolean, text?: string }) {
        this._setOption('tooltip', value);
    }

    
    get attributes(): any {
        return this._getOption('attributes');
    }
    set attributes(value: any) {
        this._setOption('attributes', value);
    }

    
    get coordinates(): Array<number> {
        return this._getOption('coordinates');
    }
    set coordinates(value: Array<number>) {
        this._setOption('coordinates', value);
    }

    
    get text(): string {
        return this._getOption('text');
    }
    set text(value: string) {
        this._setOption('text', value);
    }

    
    get url(): string {
        return this._getOption('url');
    }
    set url(value: string) {
        this._setOption('url', value);
    }

    
    get value(): number {
        return this._getOption('value');
    }
    set value(value: number) {
        this._setOption('value', value);
    }

    
    get values(): Array<number> {
        return this._getOption('values');
    }
    set values(value: Array<number>) {
        this._setOption('values', value);
    }

    protected get _optionPath() {
        return 'markers';
    }


    
    get locationChildren(): QueryList<DxiLocationComponent> {
        return this._getOption('location');
    }
    set locationChildren(value) {
        this.setChildren('location', value);
    }

    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxi-marker',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'iconSrc': [{ type: Input },],
'location': [{ type: Input },],
'onClick': [{ type: Input },],
'tooltip': [{ type: Input },],
'attributes': [{ type: Input },],
'coordinates': [{ type: Input },],
'text': [{ type: Input },],
'url': [{ type: Input },],
'value': [{ type: Input },],
'values': [{ type: Input },],
'locationChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiLocationComponent), ] },],
};
}


export class DxiMarkerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxiMarkerComponent
  ],
  exports: [
    DxiMarkerComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
